module.exports = __webpack_public_path__ + "71fefe0d0dd72844341db1a017241e71.pdf";